<template>
  <div>

    <div v-html-safe="editor_data"
      id="editorData"
      class="editor_data editor-content ck-content"
      v-show="readOnly && !isEmpty(editor_data)">
    </div>

    <div
      class="editor_data"
      v-if="readOnly && isEmpty(editor_data)">
    </div>

    <ckeditor
      ref="editor"
      :key="editorKey"
      :editor="editor"
      v-model="editor_data"
      :config="editorConfig"
      @destroy="onDestroy"
      @ready="onReady"
      v-if="editor && !readOnly"
    >
    </ckeditor>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
// import BalloonEditor from '@ckeditor/ckeditor5-editor-balloon/src/ballooneditor'
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import Font from '@ckeditor/ckeditor5-font/src/font'
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import Underline from '@ckeditor/ckeditor5-basic-styles/src/underline'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'
import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import Image from '@ckeditor/ckeditor5-image/src/image'
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption'
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle'
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar'
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize'
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload'
import Link from '@ckeditor/ckeditor5-link/src/link'
import Indent from '@ckeditor/ckeditor5-indent/src/indent'
import IndentBlock from '@ckeditor/ckeditor5-indent/src/indentblock'
import HorizontalLine from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline'
import List from '@ckeditor/ckeditor5-list/src/list'
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import ptBR from '@ckeditor/ckeditor5-build-classic/build/translations/pt-br'
import PasteFromOffice from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice'
import Base64UploadAdapter from '@ckeditor/ckeditor5-image/node_modules/@ckeditor/ckeditor5-upload/src/adapters/base64uploadadapter'
import UploadAdapter from '@/util/UploadAdapter'
// import CkEditor from '@ckeditor/ckeditor5-vue'


export default {
  components: {},
  props: {
    id: {
      type: Number,
      default: null,
    },
    editor_data: {
      type: String,
      default: '',
    },
    editorType: {
      type: String,
      default: 'classic',
    },
  },
  data: function () {

    const items = [      ]

    const plugins = [
      Essentials,
      Bold,
      Italic,
      Underline,
      BlockQuote,
      Heading,
      Image,
      ImageCaption,
      ImageStyle,
      ImageToolbar,
      ImageUpload,
      ImageResize,
      HorizontalLine,
      Link,
      Indent,
      IndentBlock,
      Font,
      List,
      MediaEmbed,
      Table,
      TableToolbar,
      Alignment,
      PasteFromOffice,
    ]

    return {
      editorKey: 0,
      readOnly: true,
      editor: null,
      editorConfig: {
        parentId: null,
        extraPlugins: [],
        // language: ptBR,
        plugins: plugins,
        mediaEmbed: {
          previewsInData: true
        },
        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph',
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2',
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3',
            },
          ],
        },
        // Configure the available image resize options.
        resizeOptions: [
          {
            name: 'imageResize:original',
            label: 'Original',
            value: null,
          },
          {
            name: 'imageResize:50',
            label: '50%',
            value: '50',
          },
          {
            name: 'imageResize:75',
            label: '75%',
            value: '75',
          },
        ],
        toolbar: {
          items: items,
          shouldNotGroupWhenFull: true
        },
        image: {
          // Configure the available styles.
          styles: ['alignLeft', 'alignCenter', 'alignRight'],

          // Configure the available image resize options.
          resizeOptions: [
            {
              name: 'imageResize:original',
              value: null,
              icon: 'original',
            },
            {
              name: 'imageResize:50',
              value: '50',
              icon: 'medium',
            },
            {
              name: 'imageResize:75',
              value: '75',
              icon: 'large',
            },
          ],

          // You need to configure the image toolbar, too, so it shows the new style
          // buttons as well as the resize buttons.
          toolbar: [
            'imageStyle:alignLeft',
            'imageStyle:alignCenter',
            'imageStyle:alignRight',
            '|',
            'imageResize',
            '|',
            'imageTextAlternative',
          ],
        },
      },

      blurTimeout: null
    }
  },
  watch: {
    id: function (val) {
      this.editorConfig.parentId = val
      this.editorKey++
    },
  },
  methods: {
    onDestroy() {
      this.$emit('destroy')
    },
    onReady() {
      const editor = this.$refs.editor.$_instance
      const view = !this.isEmpty(this.$refs.editor) && !this.isEmpty(editor) ? editor.editing.view : null

      const toolbarElement = editor.ui.view.toolbar.element;
      toolbarElement.style.display = 'none';
    },
    turnEditorVisible() {
      this.readOnly = true
    }
  },
  computed: {

  },
  beforeMount() {
    import('@ckeditor/ckeditor5-editor-classic/src/classiceditor').then(({ default: ClassicEditor }) => {
      this.editor = ClassicEditor
    })
    this.editorConfig.parentId = this.id
  },
  created() {},
  mounted() {

  },
  beforeDestroy() {
    if (!this.isEmpty(this.$refs.editor) && !this.isEmpty(this.$refs.editor.$_instance)) {
      this.$refs.editor.$_instance.destroy()
    }

    this.destroyChilds(this)
  }
}
</script>

<style>
.editor_data {
  border: 1px solid #eee !important;
  border-radius: 5px;
  -webkit-transition: border-color 0.5s ease-out;
  padding: 10px;
  cursor: text;
}
</style>
